<!-- step 1/2/3 -->
<div class="main">
  <div class="title">
    <h4 [ngStyle]="{ 'margin-bottom.px': 16,'margin-top.px': 16 }">{{ 'DetailInfo.ReviewResult' | translate }}</h4>
  </div>
  <div class="content">
    <nz-list nzBordered>
      <nz-list-item>
        <nz-radio-group [ngModel]="radioValue" (ngModelChange)="nzRadioChang($event)">
          <label nz-radio nzValue="agree">{{ 'DetailInfo.Approve' | translate }}</label>
          <label nz-radio nzValue="reject">{{ 'DetailInfo.Reject' | translate }}</label>
        </nz-radio-group>
        <textarea class="remark" *ngIf="step===3 && radioValue==='agree'" nz-input
          placeholder="{{'DetailInfo.ApprovePlaceholder' | translate}}" nzAutosize [ngModel]="agreeRemarkText"
          (ngModelChange)="nzInputChang($event,radioValue)">
        </textarea>
        <textarea class="remark" *ngIf="radioValue==='reject'" nz-input
          placeholder="{{'DetailInfo.RejectPlaceholder' | translate}}" nzAutosize [ngModel]="rejectRemarkText"
          (ngModelChange)="nzInputChang($event,radioValue)">
        </textarea>
      </nz-list-item>
    </nz-list>
  </div>
</div>